import script from "./PwaLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./PwaLayout.vue?vue&type=script&setup=true&lang=ts"

import "./PwaLayout.vue?vue&type=style&index=0&id=2d7f2ee0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7f2ee0"]])

export default __exports__